<template>
  <form v-if="editableDealership" class="page-content -no-padding" @submit.prevent="submit" @change="formChange">
    <div class="page-content -auto-height -form">
      <h2 class="section-title -strong -mb">Dealership</h2>

      <div class="halves">
        <label>
          <strong> Name</strong>
          <span v-if="editableErrors.name" class="alert -inline -danger">
            Name {{ editableErrors.name.join(", ") }}
          </span>
          <input v-model="editableDealership.name" type="text" placeholder="Name" @keyup="formChange" />
        </label>

        <label>
          <strong>Dealership Id</strong>: Identifier for the dealership, use by the API to identify this dealership.
          <span v-if="editableErrors.dealership_id" class="alert -inline -danger">
            Dealership Id {{ editableErrors.dealership_id.join(", ") }}
          </span>
          <input
            v-model="editableDealership.dealership_id"
            type="text"
            placeholder="Dealership Id"
            @keyup="formChange"
          />
        </label>
        <label class="input -checkbox -mb">
          <input v-model="editableDealership.disable" type="checkbox" />
          Disable widget
        </label>
      </div>

      <h2 class="section-title -strong -mb">Address
        <i v-if="editableDealership.address_confirmed" class="svg -globe-green" style="vertical-align: text-bottom;"></i>
        <action-button
          text="Search on map"
          glyph="svg -search"
          style="width: 200px; padding-top: 3px; margin-right: 10px; float: inline-end;"
          :state="searchMapState"
          @pressed="searchOnMap"
        ></action-button>
        <action-button
          text="Address tools"
          glyph="svg -tools"
          style="width: 250px; padding-top: 3px; float: inline-end;"
          @pressed="openModalWindow"
        ></action-button>
      </h2>
      <div>
        <modal id="my-modal" v-model:visible="showModal" >

            <h2 class="section-title -strong -mb" @click="modalInfo" ><i class="svg -tools" style="vertical-align: text-bottom;"></i>Address tools</h2>
          <label>
              <strong>Formatted Address</strong>
              <input id="address-data" v-model="formattedAddress" type="text" :readonly=true class="address-data"/>
          </label>
          <div class="halves">
          <label>
            <strong>Street</strong>
            <input  v-model="addressStreet" type="text" :readonly=true />
          </label>
            <label style="margin-right: 0; float: right;">
              <strong>Street</strong>
              <input  v-model="addressStreet2" type="text" :readonly=true />
            </label>
          </div>
          <div class="halves">
          <label>
            <strong>City</strong>
            <input v-model="addressCity" type="text" :readonly=true />
          </label>
          <label style="margin-right: 0; float: right;">
            <strong>Postal Code</strong>
            <input v-model="addressCode" type="text" :readonly=true />
          </label>
            <a v-if="plusCode" :href="'https://plus.codes/'+plusCode" target="_blank"><i class="svg -white -globe" style="vertical-align: middle;"></i>PlusCode {{plusCode}}</a>
            <hr>
            </div>
                <action-button
                  text="Validate address on Google"
                  glyph="svg -download"
                  :state="editableFormState"
                  @pressed="validateAddress(editableDealership)"
                ></action-button>
          <hr>
          <action-button
            text="Update address"
            glyph="svg -save"
            :state="editableFormState"
            @pressed="updateFromGoogle"></action-button>
        </modal>

        <!-- Search Results Modal -->
        <modal id="search-results-modal" v-model:visible="showSearchResults">
          <h2 class="section-title -strong -mb"><i class="svg -search" style="vertical-align: text-bottom;"></i>Search Results</h2>
          <label>Select a location from the results:</label>

          <div class="search-results-list">
            <div v-if="searchResults.length === 0" class="alert -inline -danger">
              No results found for the given address
            </div>
            <div v-for="(result, index) in searchResults" :key="index" class="search-result-item">
              <div class="result-content">
                <strong>{{ result.display_name }}</strong>
                <p style="font-size: 0.9em; color: #666; margin: 5px 0 0 0;">
                  Lat: {{ result.lat }} | Lon: {{ result.lon }}
                </p>
              </div>
              <action-button
                text="Select"
                class="-small"
                :state="editableFormState"
                @pressed="selectSearchResult(result)"
              />
            </div>
          </div>
        </modal>
      </div>

      <div class="halves">
        <label>
          <span v-if="editableErrors.address_street1" class="alert -inline -danger">
            Street 1 {{ editableErrors.address_street1.join(", ") }}
          </span>
          <input v-model="editableDealership.address_street1" type="text" placeholder="Street 1" @keyup="formChange" />
        </label>

        <label>
          <span v-if="editableErrors.address_street2" class="alert -inline -danger">
            Street 2 {{ editableErrors.address_street2.join(", ") }}
          </span>
          <input v-model="editableDealership.address_street2" type="text" placeholder="Street 2" @keyup="formChange" />
        </label>

        <label>
          <span v-if="editableErrors.city" class="alert -inline -danger">
            City {{ editableErrors.city.join(", ") }}
          </span>
          <input v-model="editableDealership.city" type="text" placeholder="City" @keyup="formChange"
        /></label>

        <label
          ><span v-if="editableErrors.region" class="alert -inline -danger">
            Region {{ editableErrors.region.join(", ") }}
          </span>
          <input v-model="editableDealership.region" type="text" placeholder="Region" @keyup="formChange"
        /></label>

        <label>
          <span v-if="editableErrors.post_code" class="alert -inline -danger">
            Post Code {{ editableErrors.post_code.join(", ") }}
          </span>
          <input v-model="editableDealership.post_code" type="text" placeholder="Post Code" @keyup="formChange" />
        </label>
        <label>
        <a v-if="editableDealership.global_code" :href="'https://plus.codes/'+editableDealership.global_code" style="display: flow;margin-top: 15px;" target="_blank"><i class="svg -white -globe" style="vertical-align: middle;"></i>PlusCode {{editableDealership.global_code}}</a>
        </label>
      </div>
      <h2 class="section-title -strong -mb">Last address from widget
          <action-button
            text="Update address from widget"
            :state="editableFormState"
            style="width: 300px; padding-top: 3px; float: inline-end;"
            @pressed="updateAddressFromWidget(editableDealership)"
          ></action-button>
      </h2>
        <label>
          <input v-model="editableDealership.address_from_widget" type="text" :readonly=true />
        </label>

      <hr>
      <h2 class="section-title -strong -mb">Location (OpenStreetMap)</h2>
      <label class="map-help">Kliknij na mapie, aby ustawić współrzędne dealera.</label>
      <div ref="dealershipMap" class="dealership-map"></div>
      <div class="halves">
        <label>
          <strong>Latitude</strong>
          <input
            v-model="editableDealership.latitude"
            type="number"
            step="0.000001"
            placeholder="Latitude"
            @change="updateMarkerFromInputs"
          />
        </label>

        <label>
          <strong>Longitude</strong>
          <input
            v-model="editableDealership.longitude"
            type="number"
            step="0.000001"
            placeholder="Longitude"
            @change="updateMarkerFromInputs"
          />
        </label>
      </div>

      <hr>
      <h2 class="section-title -strong -mb">Details</h2>

      <label>
        Opening Hours
        <span v-if="editableErrors.opening_hours" class="alert -inline -danger">
          Opening Hours {{ editableErrors.opening_hours.join(", ") }}
        </span>
        <input v-model="editableDealership.opening_hours" type="text" placeholder="Opening Hours" @keyup="formChange" />
      </label>

      <div class="halves">
        <label class="input -checkbox -mb">
          <input v-model="editableDealership.finance_available" type="checkbox" />
          Finance Available
        </label>
        <label>
          Finance Companies
          <span v-if="editableErrors.finance_companies" class="alert -inline -danger">
            Finance Companies {{ editableErrors.finance_companies.join(", ") }}
          </span>
          <input
            v-model="editableDealership.finance_companies"
            type="text"
            placeholder="Finance Companies"
            @keyup="formChange"
          />
        </label>
        <label>
          All Stock Link Text
          <span v-if="editableErrors.all_stock_text" class="alert -inline -danger">
            All Stock Link Text {{ editableErrors.all_stock_text.join(", ") }}
          </span>
          <input
            v-model="editableDealership.all_stock_text"
            type="text"
            placeholder="All Stock Link Text"
            @keyup="formChange"
          />
        </label>

        <label>
          All Stock Link URL
          <span v-if="editableErrors.all_stock_url" class="alert -inline -danger">
            All Stock Link URL {{ editableErrors.all_stock_url.join(", ") }}
          </span>
          <input
            v-model="editableDealership.all_stock_url"
            type="text"
            placeholder="All Stock Link URL"
            @keyup="formChange"
          />
        </label>

        <label class="input -checkbox -mb">
          <input v-model="editableDealership.accepts_trade_ins" type="checkbox" />
          Accepts Trade-ins
        </label>
      </div>

      <h2 class="section-title -strong -mb">Suggested Questions</h2>
      <label>These will be suggested conversation starters when there is no vehicle in the context.</label>
      <form @submit="addSuggestedQuestion">
        <input v-model="newSuggestedQuestion" type="text" />
        <span v-if="suggestedQuestionError" class="alert -inline -danger">
          {{ suggestedQuestionError }}
        </span>
        <action-button
          v-else
          text="Add Suggested Questions"
          :state="editableFormState"
          @pressed="addSuggestedQuestion"
        ></action-button>

        <span v-if="editableErrors.suggested_questions" class="alert -inline -danger">
          {{ editableErrors.suggested_questions[0] }}
        </span>
      </form>

      <div
        v-if="editableDealership.suggested_questions && editableDealership.suggested_questions.length > 0"
        class="basic-list -mt"
      >
        <hr />
        <ul>
          <li v-for="suggested_query in editableDealership.suggested_questions" :key="suggested_query">
            {{ suggested_query }}

            <action-button
              :state="editableFormState"
              text="Remove"
              class="-danger -small -right"
              @pressed="removeSuggestedQuestion(suggested_query)"
            />
          </li>
        </ul>
      </div>

      <hr />

      <h2 class="section-title -strong -mb">Notifications</h2>

      <label>
        Notification E-mail
        <input v-model="newEmail" type="text" />
      </label>
      <action-button text="Add Email Address" @pressed="addEmail"></action-button>

      <span v-if="editableErrors.notification_emails" class="alert -inline -danger">
        {{ editableErrors.notification_emails[0] }}
      </span>
      <div
        v-if="editableDealership.notification_emails && editableDealership.notification_emails.length > 0"
        class="basic-list -mt"
      >
        <ul>
          <li v-for="email in editableDealership.notification_emails" :key="email">
            {{ email }}
            <action-button text="Remove" class="-danger -small -right" @pressed="removeEmail(email)" />
          </li>
        </ul>
      </div>
    </div>

    <div class="page-content -auto-height">
      <span v-if="Object.keys(editableErrors).length" class="alert -inline -danger">
        Please correct the following errors
        <ul>
          <li v-for="error in Object.entries(editableErrors)" :key="error">
            {{ titleCase(error[0]) }} {{ error[1].join(", ") }}
          </li>
        </ul>
      </span>

      <action-button
        :text="buttonText"
        :state="editableFormState"
        @pressed="submit"
        @revertState="revertState"
      ></action-button>

      <hr />

      <action-button
        v-if="isAdmin"
        :text="clearProblems"
        :state="editableFormState"
        @pressed="clearDealershipProblems(editableDealership)"
      ></action-button>

    </div>
  </form>
</template>

<script>
import _ from "underscore";
import {mapGetters} from "vuex";

import actionButton from "@/components/actionButton";
import modal from "@/components/modal";

export default {
  name: "DealershipForm",

  components: {
    actionButton,
    modal
  },
  props: {
    dealership: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    formState: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: "Create Dealership"
    },
    clearProblems: {
      type: String,
      default: "Clear Problem list for this Dealership"
    },
  },
  data() {
    return {
      editableDealership: null,
      editableErrors: {},
      editableFormState: "normal",
      newEmail: "",
      newSuggestedQuestion: "",
      suggestedQuestionError: "",
      formattedAddress: "",
      addressStreet: "",
      addressStreet2: "",
      addressCity: "",
      addressCode: "",
      plusCode: "",
      addressData: null,
      showModal: false,
      showSearchResults: false,
      searchResults: [],
      searchMapState: "normal",
      google_address: null,
      mapInstance: null,
      mapMarker: null,
      leafletPromise: null,
      longitude: null,
      latitude: null
    };
  },
  computed: {
    ...mapGetters(["isAdmin"])
  },
  watch: {
    dealership() {
      if(this.editableDealership.suggested_questions !== this.dealership.suggested_questions) {
        this.newSuggestedQuestion = null;
      };
      if(this.editableDealership.notification_emails !== this.dealership.notification_emails) {
        this.newEmail = null;
      };

      this.editableDealership = this.dealership;
      this.editableErrors = {};
      this.editableFormState = "normal";
      this.$nextTick(() => {
        this.initMap();
        this.syncMapFromDealership();
      });
    },
    errors(errors) {
      this.editableErrors = errors;
    },
    formState(formState) {
      this.editableFormState = formState;
    }
  },

  mounted() {
    this.editableDealership = this.dealership;
    this.editableErrors = this.errors;
    this.editableFormState = this.formState;
    this.$nextTick(() => this.initMap());
  },

  beforeDestroy() {
    if (this.mapInstance) {
      this.mapInstance.remove();
      this.mapInstance = null;
    }
  },

  methods: {
    submit() {
      if (this.editableFormState !== "normal") return;

      const data = {
        id: this.editableDealership.id,
        dealership_id: this.editableDealership.dealership_id || null,
        disable: this.editableDealership.disable || false,
        name: this.editableDealership.name || "",
        address_street1: this.editableDealership.address_street1 || "",
        address_street2: this.editableDealership.address_street2 || "",
        city: this.editableDealership.city || "",
        region: this.editableDealership.region || "",
        post_code: this.editableDealership.post_code || "",
        opening_hours: this.editableDealership.opening_hours || "",
        finance_available: `${this.editableDealership.finance_available}`,
        finance_companies: this.editableDealership.finance_companies || "",
        all_stock_text: this.editableDealership.all_stock_text || "",
        all_stock_url: this.editableDealership.all_stock_url || "",
        accepts_trade_ins: `${this.editableDealership.accepts_trade_ins}`,
        suggested_questions: [this.editableDealership.suggested_questions, this.newSuggestedQuestion].flat().filter(n => n),
        notification_emails: [this.editableDealership.notification_emails, this.newEmail].flat().filter(n => n),
        global_code: this.editableDealership.global_code || "",
        address_confirmed: this.editableDealership.address_confirmed || false,
        latitude: this.editableDealership.latitude,
        longitude: this.editableDealership.longitude
      };

      this.$emit("submit", data);
    },

    revertState() {
      this.$emit("revertState");
    },

    formChange() {
      this.$emit("changeMade");
    },
    openModalWindow() {
      this.showModal = true;
    },
    normalizeCoordinate(value) {
      const parsed = parseFloat(value);
      return Number.isFinite(parsed) ? parsed : null;
    },
    loadLeaflet() {
      if (window.L) return Promise.resolve(window.L);
      if (this.leafletPromise) return this.leafletPromise;

      const leafletCssId = "leaflet-css";
      const leafletJsId = "leaflet-js";

      if (!document.getElementById(leafletCssId)) {
        const link = document.createElement("link");
        link.id = leafletCssId;
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
        document.head.appendChild(link);
      }

      this.leafletPromise = new Promise((resolve, reject) => {
        const existingScript = document.getElementById(leafletJsId);
        if (existingScript && window.L) {
          resolve(window.L);
          return;
        }

        const onReady = () => {
          if (window.L) resolve(window.L);
          else reject(new Error("Leaflet not available"));
        };

        if (existingScript) {
          existingScript.addEventListener("load", onReady, {once: true});
          existingScript.addEventListener("error", reject, {once: true});
          return;
        }

        const script = document.createElement("script");
        script.id = leafletJsId;
        script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
        script.async = true;
        script.onload = onReady;
        script.onerror = reject;
        document.body.appendChild(script);
      });

      return this.leafletPromise;
    },
    hasCoordinates() {
      return (
        Number.isFinite(parseFloat(this.editableDealership.latitude)) &&
        Number.isFinite(parseFloat(this.editableDealership.longitude))
      );
    },
    getCoordinates() {
      return {
        latitude: parseFloat(this.editableDealership.latitude),
        longitude: parseFloat(this.editableDealership.longitude)
      };
    },
    initMap() {
      if (this.mapInstance || !this.$refs.dealershipMap) return;

      this.loadLeaflet()
        .then((L) => {
          if (this.mapInstance || !this.$refs.dealershipMap) return;

          const defaultCenter = [51.5074, -0.1278];
          const center = this.hasCoordinates()
            ? [this.getCoordinates().latitude, this.getCoordinates().longitude]
            : defaultCenter;

          this.mapInstance = L.map(this.$refs.dealershipMap).setView(center, this.hasCoordinates() ? 14 : 5);

          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "&copy; OpenStreetMap contributors"
          }).addTo(this.mapInstance);

          this.mapInstance.on("click", (event) => {
            this.setCoordinatesFromMap(event.latlng.lat, event.latlng.lng);
          });

          this.syncMapFromDealership();
        })
        .catch((error) => {
          console.error("Unable to load OpenStreetMap", error);
        });
    },
    setCoordinatesFromMap(latitude, longitude) {
      this.editableDealership.latitude = Number(latitude).toFixed(6);
      this.editableDealership.longitude = Number(longitude).toFixed(6);
      this.setMarker(parseFloat(this.editableDealership.latitude), parseFloat(this.editableDealership.longitude));
      this.formChange();
    },
    setMarker(latitude, longitude) {
      if (!this.mapInstance || !window.L) return;

      if (!this.mapMarker) {
        this.mapMarker = window.L.marker([latitude, longitude]).addTo(this.mapInstance);
      } else {
        this.mapMarker.setLatLng([latitude, longitude]);
      }
      this.mapInstance.setView([latitude, longitude], 14);
    },
    syncMapFromDealership() {
      if (!this.mapInstance) return;

      if (this.hasCoordinates()) {
        const {latitude, longitude} = this.getCoordinates();
        this.setMarker(latitude, longitude);
      } else if (this.mapMarker) {
        this.mapInstance.removeLayer(this.mapMarker);
        this.mapMarker = null;
      }
    },
    updateMarkerFromInputs() {
      if (!this.hasCoordinates()) return;

      const {latitude, longitude} = this.getCoordinates();
      this.setMarker(latitude, longitude);
      this.formChange();
    },
    googleAddressData(data) {
      return this.addressData.$data;
    },
    googleAddress() {
      this.google_address.then((a) => {
        console.log(a.result.address);
        this.addressData = a.result.address;
        this.formattedAddress = this.addressData.formattedAddress;
        this.addressStreet = this.addressData.postalAddress.addressLines[0];
        this.addressStreet2 = this.addressData.postalAddress.addressLines[1];
        this.addressCity = this.addressData.postalAddress.locality;
        this.addressCode = this.addressData.postalAddress.postalCode;
        this.plusCode = a.result.geocode?.plusCode?.globalCode;
        this.latitude = a.result.geocode?.location?.latitude;
        this.longitude = a.result.geocode?.location?.longitude;
        this.showModal = true;
      });


    },
    addEmail() {
      if (this.newEmail.trim().length > 0) {
        if (this.editableDealership.notification_emails === undefined) {
          this.editableDealership.notification_emails = [];
        }
        this.submit();
      }
    },

    removeEmail(email) {
      const dupe = _.clone(this.editableDealership);
      dupe.notification_emails = _.without(dupe.notification_emails, email);
      this.editableDealership = dupe;
      this.submit();
    },

    addSuggestedQuestion() {
      if (this.editableDealership.suggested_questions.length >= 5) {
        this.suggestedQuestionError = "You can have a maximum of 5 suggested questions";
      } else if (this.newSuggestedQuestion.trim().length > 0) {
        this.submit();
      }
    },
    updateAddressFromWidget(data) {
      this.$store
        .dispatch("updateAddressFromWidgetAPI", data)
        .then(() => {
          // Pobierz świeże dane dealership
          return this.$store.dispatch("fetchDealerships");
        })
        .then(() => {
          // Odśwież dane w formie
          const updatedDealership = this.$store.state.dealerships.all.find(d => d.id === data.id);
          if (updatedDealership) {
            this.editableDealership = updatedDealership;
            this.editableErrors = {};
            this.editableFormState = "normal";
          }
        })
        .catch((err) => {
          console.error("Error updating address from widget:", err);
        });
    },
    validateAddress(data) {
      const resp = this.$store
        .dispatch("validateAddressOnGoogle", data);
      this.google_address = resp;
      this.googleAddress();
    },
    updateFromGoogle() {
       this.editableDealership.address_street1 = this.addressStreet;
       this.editableDealership.address_street2 = this.addressStreet2;
       this.editableDealership.city = this.addressCity;
       this.editableDealership.post_code = this.addressCode;
       this.editableDealership.global_code = this.plusCode;
       this.editableDealership.latitude = this.latitude;
        this.editableDealership.longitude = this.longitude;
       this.editableDealership.address_confirmed = true;
       this.submit();
       this.showModal = false;
     },
    removeSuggestedQuestion(email) {
      const dupe = _.clone(this.editableDealership);
      dupe.suggested_questions = _.without(dupe.suggested_questions, email);
      this.editableDealership = dupe;
      this.submit();
      this.suggestedQuestionError = "";
    },

    searchOnMap() {
      // Build address string from form fields
      const addressParts = [
        this.editableDealership.address_street1,
        this.editableDealership.address_street2,
        this.editableDealership.city,
        this.editableDealership.region,
        this.editableDealership.post_code
      ].filter(part => part && part.trim().length > 0);

      if (addressParts.length === 0) {
        alert("Please fill in at least one address field to search");
        return;
      }

      const addressQuery = addressParts.join(", ");
      this.searchMapState = "loading";

      // Use Nominatim API (OpenStreetMap) to search for the address
      const nominatimUrl = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(addressQuery)}&format=json&limit=10`;

      fetch(nominatimUrl)
        .then(response => response.json())
        .then(results => {
          console.log("Search results:", results);
          this.searchResults = results;
          this.searchMapState = "normal";

          if (results.length === 0) {
            this.showSearchResults = true;
          } else if (results.length === 1) {
            // If only one result, select it automatically
            this.selectSearchResult(results[0]);
          } else {
            // If multiple results, show modal for selection
            this.showSearchResults = true;
          }
        })
        .catch(error => {
          console.error("Error searching address:", error);
          alert("Error searching for address. Please try again.");
          this.searchMapState = "normal";
        });
    },

    selectSearchResult(result) {
      // Set coordinates from selected result
      this.editableDealership.latitude = parseFloat(result.lat);
      this.editableDealership.longitude = parseFloat(result.lon);

      // Update map marker
      if (this.mapInstance) {
        this.setMarker(parseFloat(result.lat), parseFloat(result.lon));
      }

      // Close modal
      this.showSearchResults = false;
      this.searchResults = [];

      // Mark form as changed
      this.formChange();

      // Optional: Show success message
      console.log(`Location set to: ${result.display_name}`);
    },

    modalInfo() {
      console.log(this.$("#my-modal .address-data"));
    },

    titleCase(str) {
      return str
        .replace("_", " ")
        .split(" ")
        .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
        .join(" ");
    },
    clearDealershipProblems(data) {
      const resp =this.$store
        .dispatch("clearDealershipProblemsAPI", data);
      console.log(resp);
      this.$store.dispatch("fetchWrongCfgEvents");
    }
  }
};
</script>
<style>
.dealership-map {
  width: 100%;
  height: 320px;
  margin: 10px 0 15px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  z-index: 98;
}

.map-help {
  margin-bottom: 8px;
}

.search-results-list {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 15px 0;
}

.search-result-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  gap: 15px;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item:hover {
  background-color: #f9f9f9;
}

.result-content {
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;
}

</style>
